import { Box, Button, Typography } from '@mui/material'
import strings from 'strings'

const t = strings.ROO_EXPORT_SETTINGS

interface RooExportTableToolbarProps {
  selectionCount: number
  onConfigureRadii: () => void
  onRemove: () => void
}

const RooExportTableToolbar = ({
  selectionCount,
  onConfigureRadii,
  onRemove,
}: RooExportTableToolbarProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        justifyContent: 'space-between',
        gap: { xs: 1, sm: 0 },
        px: 2,
        py: 1,
        borderBottom: '1px solid #8080803b',
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {selectionCount === 0
          ? t.TOOLBAR_HINT
          : selectionCount === 1
          ? t.TOOLBAR_SELECTED_SINGLE
          : t.TOOLBAR_SELECTED_PLURAL.replace('{0}', String(selectionCount))}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
        <Button
          variant="outlined"
          size="small"
          disabled={selectionCount === 0}
          onClick={onConfigureRadii}
          sx={{ borderRadius: '20px', px: 2, whiteSpace: 'nowrap' }}
        >
          {selectionCount > 0
            ? `${t.CONFIGURE_RADIUS} (${selectionCount})`
            : t.CONFIGURE_RADIUS}
        </Button>
        <Button
          variant="outlined"
          size="small"
          color="error"
          disabled={selectionCount === 0}
          onClick={onRemove}
          sx={{ borderRadius: '20px', px: 2, whiteSpace: 'nowrap' }}
        >
          {selectionCount > 0 ? `${t.REMOVE} (${selectionCount})` : t.REMOVE}
        </Button>
      </Box>
    </Box>
  )
}

export default RooExportTableToolbar
